import { render, staticRenderFns } from "./RegisterUserOPTModal.vue?vue&type=template&id=be97751e&scoped=true"
import script from "./RegisterUserOPTModal.vue?vue&type=script&lang=js"
export * from "./RegisterUserOPTModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterUserOPTModal.vue?vue&type=style&index=0&id=be97751e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be97751e",
  null
  
)

export default component.exports